import gql from "graphql-tag";

export const SET_DEFAULT_ORGANIZATION = gql`
  mutation setDefaultOrganization($userOrganizationPreferenceData: UserOrganizationPreferenceInput!) {
    setDefaultOrganization(
      userOrganizationPreferenceData: $userOrganizationPreferenceData
    ) {
      userOrganizationPreference {
        id
      }
    }
  }
`;

export const UPDATE_DEFAULT_ORGANIZATION = gql`
  mutation updateDefaultOrganization($id: ID!, $defaultOrganizationId: ID!) {
    updateDefaultOrganization(
      id: $id,
      defaultOrganizationId: $defaultOrganizationId
    ) {
      userOrganizationPreference {
        id
        defaultOrganization {
          id
        }
      }
    }
  }
`;
